import { useEffect, useRef, useState } from "react";
import { Save } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";
import RichTextEditor from "@/components/admin/RichTextEditor";
import MediaPicker from "@/components/admin/MediaPicker";

const inputCls = "w-full border border-lp-border rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-lp-cyan";

export default function PageEditor() {
  const [p, setP] = useState(null);
  const [saved, setSaved] = useState(false);
  const [picker, setPicker] = useState(null); // 'hero' | 'rte'
  const insertRef = useRef(null);

  useEffect(() => { api.get("/pages/about").then((r) => setP(r.data)).catch(() => setP({ title: "", intro: "", hero_image: "", content: "", seo: {} })); }, []);
  if (!p) return <div className="text-lp-muted">Loading…</div>;

  const save = async () => { await api.put("/admin/pages/about", p); setSaved(true); setTimeout(() => setSaved(false), 2000); };

  return (
    <div className="max-w-3xl">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-heading font-700 text-2xl text-lp-blue">About Page</h1>
        <button onClick={save} data-testid="page-save" className="inline-flex items-center gap-2 bg-lp-blue text-white font-600 px-5 py-2.5 rounded-sm"><Save size={16} /> {saved ? "Saved ✓" : "Save"}</button>
      </div>
      <div className="bg-white border border-lp-border rounded-sm p-6 space-y-4">
        <div><label className="text-xs font-600 text-lp-ink">Title</label><input value={p.title || ""} onChange={(e) => setP({ ...p, title: e.target.value })} className={inputCls + " mt-1"} /></div>
        <div><label className="text-xs font-600 text-lp-ink">Intro</label><textarea rows={2} value={p.intro || ""} onChange={(e) => setP({ ...p, intro: e.target.value })} className={inputCls + " mt-1"} /></div>
        <div>
          <label className="text-xs font-600 text-lp-ink">Hero Image</label>
          <div className="flex items-center gap-3 mt-1">
            {p.hero_image && <img src={mediaUrl(p.hero_image)} alt="" className="h-12 w-12 object-cover rounded-sm border border-lp-border" />}
            <input value={p.hero_image || ""} onChange={(e) => setP({ ...p, hero_image: e.target.value })} className={inputCls} />
            <button type="button" onClick={() => setPicker("hero")} className="shrink-0 border border-lp-blue text-lp-blue font-600 px-3 py-2 rounded-sm text-sm">Library</button>
          </div>
        </div>
        <div><label className="text-xs font-600 text-lp-ink">Content</label><div className="mt-1"><RichTextEditor value={p.content || ""} onChange={(html) => setP((prev) => ({ ...prev, content: html }))} insertRef={insertRef} onOpenLibrary={() => setPicker("rte")} /></div></div>
        <div className="grid grid-cols-1 gap-3 border-t border-lp-border pt-4">
          <div><label className="text-xs font-600 text-lp-ink">SEO Title</label><input value={p.seo?.title || ""} onChange={(e) => setP({ ...p, seo: { ...p.seo, title: e.target.value } })} className={inputCls + " mt-1"} /></div>
          <div><label className="text-xs font-600 text-lp-ink">SEO Description</label><textarea rows={2} value={p.seo?.description || ""} onChange={(e) => setP({ ...p, seo: { ...p.seo, description: e.target.value } })} className={inputCls + " mt-1"} /></div>
        </div>
      </div>
      <MediaPicker open={!!picker} onClose={() => setPicker(null)} onSelect={(url) => { if (picker === "hero") setP((prev) => ({ ...prev, hero_image: url })); else if (picker === "rte" && insertRef.current) insertRef.current(url); }} />
    </div>
  );
}
